import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6845854e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-[#F5F5F5] w-[100%] info-building" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "sub" }
const _hoisted_4 = { class: "w-[1200px] mx-auto pb-[60px] px-60px box-sizing max-[750px]:w-[100%]" }

import useBanner from "@/hooks/useBanner";
import { ref } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'PartyBuilding',
  setup(__props) {

const name = ref("");
const englistName = ref("");
const style = ref({});
useBanner(function (meneItem) {
  if (!meneItem.banner) return;
  style.value = {
    "background-image": `url(${meneItem.banner})`,
  };
  name.value = meneItem.name;
  meneItem.remark && (englistName.value = meneItem.remark);
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "adv",
      style: _normalizeStyle(style.value)
    }, [
      _createElementVNode("p", _hoisted_2, _toDisplayString(name.value), 1),
      _createElementVNode("i", _hoisted_3, _toDisplayString(englistName.value), 1)
    ], 4),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_router_view)
    ])
  ]))
}
}

})